import { render, staticRenderFns } from "./OrderVehicleAdd.vue?vue&type=template&id=24077139"
import script from "./OrderVehicleAdd.vue?vue&type=script&lang=js"
export * from "./OrderVehicleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports